export enum PermissionType {
  PublicDataAccess = 0,
  Create = 100,
  Read = 101,
  Update = 102,
  Delete = 103
}
